export const ALLOWED_FILE_TYPES = {
  // keep in sync with lang-js/apps/media/src/services/imageProcessor.ts
  images: [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/webp",
    "image/gif",
    "image/tiff",
    "image/bmp",
    "image/heic",
    "image/heif",
    "image/svg+xml",
    "image/NEF",
    "image/x-adobe-dng",
  ],
  // top 9 video formats in our db
  // after these, the number of videos for other formats are in double digits
  videos: [
    "video/mp4",
    "video/quicktime",
    "video/webm",
    "video/x-ms-wmv",
    "video/x-matroska",
    "video/mpeg",
    "video/avi",
    "video/x-m4v",
    "video/3gpp",
  ],
  others: ["*/*"],
};
